export default "__VITE_ASSET__90d26116__"